import { render, staticRenderFns } from "./inquiryView.vue?vue&type=template&id=c2e82db6"
import script from "./inquiryView.vue?vue&type=script&lang=js"
export * from "./inquiryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports